export default __webpack_public_path__ + "static/media/serviceImage1.aab85089.jpg";